enum ChallengeKind {
  sms = 'sms',
  biometric = 'biometric',
  email = 'email',
}

export default ChallengeKind;
